import { Box, Grid, Typography } from "@mui/material";
import diamond from "../../assets/diamond.png";
import { useTheme as useCustomTheme } from "../../style/theme";

const MyStore = () => {
  const { mode } = useCustomTheme();

  return (
    <div>
      <Grid container sx={{ marginTop: 2 }}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: { xs: "space-between", sm: "space-around" },
              borderRadius: 3,
              border: mode === "light"
                ? "1px solid #e5e7eb"
                : "1px solid #2e2e2e",
              m: 2,
              mt: 0,
              py: 2,
              alignItems: "center",
            }}
          >
            <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
              <Typography variant="h5" x={{ fontWeight: 540 }}>
                Save 50% on all our paid services
              </Typography>
              <Typography variant="body2">
                Enjoy premium services like a boss
              </Typography>
              <Box sx={{ textAlign: "center", pt: 2 }}>
                <img src={diamond} alt="diamond" width="250" height="auto" />
              </Box>
            </Box>
            <Box
              sx={{
                textAlign: { xs: "center", md: "left" },
                mt: { xs: 2, md: 0 },
              }}
            >
              <Typography
                variant="h4"
                sx={{ fontWeight: 400, marginBottom: "10px" }}
              >
                Promotional content for other apps
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default MyStore;
